// src/layouts/DashboardLayout.jsx
import React, { useState } from "react";
import { Box } from "@mui/material";
import Navbar from "../Components/Navbar";
import Sidebar from "../Components/Sidebar";
import { Outlet } from "react-router-dom";

const DashboardLayout = ({ role }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [panelOpen, setPanelOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
    if (mobileOpen) {
      setPanelOpen(false);
    }
  };

  const handlePanelToggle = (isOpen) => {
    setPanelOpen(isOpen);
  };

  const collapsedWidth = 80;
  const expandedWidth = 320;
  const mobileCollapsed = 52;
  const mobileExpanded = 240;
  const sidebarWidth = panelOpen ? expandedWidth : collapsedWidth;
  const mobileSidebarWidth = panelOpen ? mobileExpanded : mobileCollapsed;
  return (
    <Box
      sx={{
        // display: "flex",
        minHeight: "100vh",
        overflowX: "hidden",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          filter: "blur(6px)",
          opacity: 0.75,
          zIndex: -1,
        },
      }}
    >
      {/* Sidebar */}
      <Sidebar
        role={role}
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
        onPanelToggle={handlePanelToggle}
      />

      {/* Overlay for mobile */}
      {/* {mobileOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1199,
            display: { xs: "block", md: "none" },
          }}
          onClick={handleDrawerToggle}
        />
      )} */}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: "100%",
            md: `calc(100% - ${sidebarWidth}px)`,
          },
          ml: {
            xs: 0,
            md: `${sidebarWidth}px`,
          },
          minHeight: "100vh",
          boxSizing: "border-box",
          // pt: { xs: 1, md: 1.5 },
          // pb: 3,
          // px: { xs: 1.5, sm: 2, md: 2.5 },
          transition: "margin-left 0.25s ease, width 0.25s ease",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            mx: "auto",
            overflow: "hidden",
          }}
        >
          <Navbar
            role={role}
            onMenuClick={() => setMobileOpen(!mobileOpen)}
            onDrawerToggle={handleDrawerToggle}
          />
          <Box
            sx={{
              mt: 2.5,
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
